// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const hippo = defineModel({
  id: "hippo",
  scale: 2.88, // real-world size correction (see Model.scale)
  batchId: "future",
  name: "Hippo",
  tags: ["creature","hippo","low-poly","age-of-mcp","future","water"],
  summary: "A hippo — bulky river fauna of warm wetlands.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.18,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.024, 0.022, 0.06, 6), color: "#7a6a80", position: [0.075, 0.03, 0.06] },
      { geometry: new THREE.CylinderGeometry(0.024, 0.022, 0.06, 6), color: "#7a6a80", position: [0.075, 0.03, -0.06] },
      { geometry: new THREE.CylinderGeometry(0.024, 0.022, 0.06, 6), color: "#7a6a80", position: [-0.075, 0.03, 0.06] },
      { geometry: new THREE.CylinderGeometry(0.024, 0.022, 0.06, 6), color: "#7a6a80", position: [-0.075, 0.03, -0.06] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#7a6a80", position: [0, 0.115, 0], scale: [1.7, 1.05, 1.25] },
      { geometry: new THREE.IcosahedronGeometry(0.075, 0), color: "#9486a0", position: [0, 0.085, 0], scale: [1.6, 0.5, 1.15] },
      { geometry: new THREE.BoxGeometry(0.085, 0.075, 0.1), color: "#897a90", position: [0.13, 0.115, 0] },
      { geometry: new THREE.BoxGeometry(0.055, 0.05, 0.12), color: "#897a90", position: [0.18, 0.1, 0] },
      { geometry: new THREE.BoxGeometry(0.02, 0.012, 0.1), color: "#5c4f64", position: [0.205, 0.082, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#897a90", position: [0.208, 0.118, 0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#897a90", position: [0.208, 0.118, -0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#5c4f64", position: [0.214, 0.118, 0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#5c4f64", position: [0.214, 0.118, -0.03] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#897a90", position: [0.12, 0.16, 0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.012, 0), color: "#897a90", position: [0.12, 0.16, -0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#100c12", position: [0.128, 0.165, 0.044] },
      { geometry: new THREE.IcosahedronGeometry(0.005, 0), color: "#100c12", position: [0.128, 0.165, -0.044] },
      { geometry: new THREE.ConeGeometry(0.01, 0.016, 5), color: "#7a6a80", position: [0.1, 0.168, 0.05] },
      { geometry: new THREE.ConeGeometry(0.01, 0.016, 5), color: "#7a6a80", position: [0.1, 0.168, -0.05] },
      { geometry: new THREE.ConeGeometry(0.014, 0.04, 4), color: "#7a6a80", position: [-0.16, 0.11, 0], rotation: [0, 0, 1.7] },
    ],
  animations: [],
});
